import CompanyApplyPage from '@/modules/customer/pages/CompanyApplyPage.vue'
import SubscriptionDetailPage from '@/modules/customer/pages/SubscriptionDetailPage.vue'
import SubscriptionPage from '@/modules/customer/pages/CustomerSubscriptionPage.vue'
import type { RouteRecordRaw } from 'vue-router'

const CustomerLayout = () => import('@/app/layouts/CustomerLayout.vue')
const SharedLayout = () => import('@/app/layouts/SharedLayout.vue')
const MessageLayout = () => import('@/app/layouts/MessageLayout.vue')
const DashboardPage = () => import('@/modules/customer/pages/DashboardPage.vue')
const InquiryPage = () => import('@/modules/customer/pages/CustomerInquiryPage.vue')
const InquiryDetailPage = () => import('@/modules/customer/pages/CustomerInquiryDetailPage.vue')
const CustomerAppointmentPage = () => import('@/modules/customer/pages/CustomerAppointmentPage.vue')
const CustomerAppontmentDetailPage = () => import('@/modules/customer/pages/CustomerAppontmentDetailPage.vue')
const QuotationPage = () => import('@/modules/customer/pages/CustomerQuotationPage.vue')
const QuotationDetailPage = () => import('@/modules/customer/pages/CustomerQuotationDetailPage.vue')
const MessagePage = () => import('@/modules/customer/pages/CustomerMessagePage.vue')
const MessageDetailPage = () => import('@/modules/customer/pages/CustomerMessageDetailPage.vue')
const PersonalInfoPage = () => import('@/shared/pages/PersonalInfoPage.vue')
const SavedAddressesPage = () => import('@/shared/pages/SavedAddressesPage.vue')
const SavedAddressEditPage = () => import('@/shared/pages/SavedAddressEditPage.vue')
const PaymentMethodsPage = () => import('@/shared/pages/PaymentMethodsPage.vue')
const NotificationsPage = () => import('@/modules/customer/pages/NotificationsPage.vue')
const LanguagePage = () => import('@/modules/customer/pages/LanguagePage.vue')
const HelpCenterPage = () => import('@/shared/pages/HelpCenterPage.vue')
const ContactSupportPage = () => import('@/shared/pages/ContactSupportPage.vue')
const SettingsPage = () => import('@/shared/pages/SettingsPage.vue')
const TermsPrivacyPage = () => import('@/shared/pages/TermsPrivacyPage.vue')
const DeleteAccountPage = () => import('@/shared/pages/DeleteAccountPage.vue')

export const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/customer',
    component: CustomerLayout,
    meta: { requiresAuth: true, contextType: 'customer' },
    children: [
      { path: '', redirect: { name: 'customer.dashboard' } },
      {
        path: 'dashboard',
        name: 'customer.dashboard',
        component: DashboardPage,
        meta: { title: 'Dashboard' }
      }
    ]
  },
  {
    path: '/customer',
    component: SharedLayout,
    meta: { requiresAuth: true, contextType: 'customer' },
    children: [
      {
        path: 'inquiries',
        name: 'customer.inquiries',
        component: InquiryPage,
        meta: { title: 'Inquiries' }
      },
     
      {
        path: 'inquiries/:id',
        name: 'customer.inquiries.detail',
        component: InquiryDetailPage,
        meta: { title: 'Back' }
      },
      {
        path: 'appointments',
        name: 'customer.appointments',
        component: CustomerAppointmentPage,
        meta: { title: 'Appointments' }
      },
      {
        path: 'appointments/:id',
        name: 'customer.appointments.detail',
        component: CustomerAppontmentDetailPage,
        meta: { title: 'Back' }
      },
      {
        path: 'quotations',
        name: 'customer.quotations',
        component: QuotationPage,
        meta: { title: 'Quotations' }
      },
      {
        path: 'quotations/:id',
        name: 'customer.quotations.detail',
        component: QuotationDetailPage,
        meta: { title: 'Quotation Details' }
      },
      {
        path: 'messages',
        name: 'customer.messages',
        component: MessagePage,
        meta: { title: 'Back' }
      },
      {
        path: 'subscriptions',
        name: 'customer.subscriptions',
        component: SubscriptionPage,
        meta: { title: 'Subscriptions' }
      },
      {
        path: 'subscriptions/:id',
        name: 'customer.subscriptions.detail',
        component: SubscriptionDetailPage,
        meta: { title: 'Back' }
      },
      {
        path: 'profile',
        name: 'customer.profile',
        component: PersonalInfoPage,
        meta: { title: 'Back' }
      },
      {
        path: 'saved-addresses',
        name: 'customer.saved-addresses',
        component: SavedAddressesPage,
        meta: { title: 'Back' }
      },
      {
        path: 'saved-addresses/:id',
        name: 'customer.saved-addresses.edit',
        component: SavedAddressEditPage,
        meta: { title: 'Back' }
      },
      {
        path: 'payment-methods',
        name: 'customer.payment-methods',
        component: PaymentMethodsPage,
        meta: { title: 'Back' }
      },
      {
        path: 'notifications',
        name: 'customer.notifications',
        component: NotificationsPage,
        meta: { title: 'Back' }
      },
      {
        path: 'language',
        name: 'customer.language',
        component: LanguagePage,
        meta: { title: 'Back' }
      },
      {
        path: 'help-center',
        name: 'customer.help-center',
        component: HelpCenterPage,
        meta: { title: 'Back' }
      },
      {
        path: 'contact-support',
        name: 'customer.contact-support',
        component: ContactSupportPage,
        meta: { title: 'Back' }
      },
      {
        path: 'terms-privacy',
        name: 'customer.terms-privacy',
        component: TermsPrivacyPage,
        meta: { title: 'Back' }
      },
      {
        path: 'delete-account',
        name: 'customer.delete-account',
        component: DeleteAccountPage,
        meta: { title: 'Back' }
      },
      {
        path: 'settings',
        name: 'customer.settings',
        component: SettingsPage,
        meta: { title: 'Back' }
      },
      {
        path: 'company-apply/:id',
        name: 'customer.company-apply',
        component: CompanyApplyPage,
        meta: { title: 'Back' }
      }
    ]
  },
  {
    path: '/customer',
    component: MessageLayout,
    meta: { requiresAuth: true, contextType: 'customer' },
    children: [
      {
        path: 'messages/:id',
        name: 'customer.messages.detail',
        component: MessageDetailPage,
        meta: { title: 'Back' }
      }
    ]
  }
]
